import { CHECK_OAUTH_INTERVAL_MS } from '@d-shared/config';

export default class Window {
  static getReferrer() {
    return document.referrer;
  }

  static goBack() {
    window.history.back();
  }

  /* istanbul ignore next */
  static goTo(targetUrl, _window = window) {
    _window.location.href = targetUrl;
  }

  /* istanbul ignore next */
  static async oauthWindow(url, title, config, _window = window) {
    return new Promise((resolve, reject) => {
      let checkOauth = () => {
        try {
          if (popup.closed) {
            _window.clearInterval(interval);
            reject();
          }

          if (popup.location.hostname) {
            _window.clearInterval(interval);
            resolve(popup);
          }
        } catch (e) {}
      };

      const popup = _window.open(url, title, config);
      if (popup.focus) {
        popup.focus();
      }

      const interval = _window.setInterval(checkOauth, CHECK_OAUTH_INTERVAL_MS);
    });
  }

  /* istanbul ignore next */
  static open(targetUrl, target, _window = window) {
    target = target || '_blank';
    _window.open(targetUrl, target);
  }
}
